import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getNewsEventPageData = async () => {
  const data = await fetchData(ENDPOINTS.GET.NEWS_EVENTS_PAGE, {
    method: METHODS.GET,
  });
  return data;
};
